import {
  IonPage,
  IonIcon,
  IonText,
  IonFab,
  IonFabButton,
  IonSkeletonText,
  IonThumbnail,
  IonFabList,
  IonContent,
  useIonAlert,
  useIonLoading,
  useIonModal,
  useIonToast,
} from '@ionic/react';
import { refreshCircleOutline, menuSharp, navigateCircleOutline, locateOutline, mapOutline, storefrontSharp, logInOutline, logOutOutline, chatboxEllipsesOutline, arrowBackCircleOutline, checkmarkCircleOutline, closeCircleOutline, checkmarkCircle } from "ionicons/icons";
import React, {useEffect, useState} from 'react';
import { GoogleMap, useLoadScript, Marker, Circle, InfoWindow } from '@react-google-maps/api';
import { Geolocation } from '@capacitor/geolocation';
import { useDispatch, useSelector } from "react-redux";
import getDistance from 'geolib/es/getDistance';
import { Preferences } from '@capacitor/preferences'
import { RestApi } from '../services/Api';
import { CustomerAction } from "../data/state/CustomerReducer";
import { VisitAction } from "../data/state/VisitReducer";
import { useAuth } from "../data/sessions/Auth";
import { MapCustomer } from '../models/Modal';
import { Capacitor } from "@capacitor/core";
import { Device } from '@capacitor/device';
import CheckPermissions from '../services/Permission';
import { LaunchNavigator, LaunchNavigatorOptions } from '@awesome-cordova-plugins/launch-navigator';
import { useTranslation } from 'react-i18next';
import { getRoleMenu, useConstructor } from '../services/Library';
import { BackgroundGeolocation } from "../App";
import { Browser } from '@capacitor/browser';
import ModalNote from './visit/ModalNote';
import './Map.scss';

const Map: React.FC<MapCustomer> = (props)  => {
  const { logOut } = useAuth()!;
  const dispatch = useDispatch();  
  const [presentToast] = useIonToast();
  const [presentLoading, dismissLoading] = useIonLoading();
  const [alert] = useIonAlert();
  const { t } = useTranslation(["general"]);
  const [address, setAddress] = useState<any>();
  const user = useSelector((state: any) => state.user.value);
  const getRole = getRoleMenu(user.role_menu, "customer");
  const [customer, setCustomer] = useState<any>([]);
  const [visit, setVisit] = useState<any>([]);
  const [bill, setBill] = useState<any>([]);
  const [onLoadInfoLoc, setOnLoadInfoLoc] = useState<boolean>(false);
  const [coordinates, setCoordinates] = useState<any>([]);
  const [focusLoc, setFocusLoc] = useState<any>([]);
  const [onLoadInfoCust, setOnLoadInfoCust] = useState<boolean>(false);
  
  const handleDismissNote = (e: any) => {
    if (e) {
     props.onDismissDetail(); 
    }
    dismissNote();
  };

  const [presentNote, dismissNote] = useIonModal(ModalNote, {
    customer: props.customer,
    type: "note",
    visit: props.visit,
    onDismissDetail: handleDismissNote,
  });

  const checkLocation = () => {
    currentLocation()
    setFocusLoc({
      latitude  : coordinates?.coords?.latitude,
      longitude : coordinates?.coords?.longitude
    })
  };

  const massageAlert = async (status:string,body:string) => {
    alert({
      header: t(status),
      message: body,
      cssClass: `header-alert-${status}`,
      buttons: [{ text: t('yes'), cssClass: 'alert-button-confirm', handler: (d:any) => {} }],
    })
  }

  const mockLog = async () => {
    const info = await Device.getId();
    const application = await Device.getInfo();
    await RestApi('user/mocklog','post',{
      "imei" : info.identifier,
      "application" : application
    }).then((res:any) => {
      logOut()
      props.onDismissDetail()
      massageAlert('error',"Anda Menggunakan Fake GPS")
    })
    .catch((error:any)=>{
      logOut()
      props.onDismissDetail()
      massageAlert('error',"Anda Menggunakan Fake GPS!!!!!")
    })
  }

  const { isLoaded } = useLoadScript({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_KEY_GOOGLE_MAP??''
  })

  const guessLocation = (timeout:any) =>{
    return new Promise(function (resolve) {
      let id:any;
      let lastLocation:any;
      BackgroundGeolocation.addWatcher(
        {
          requestPermissions: true,
          stale: false,
          backgroundMessage: "Cancel to prevent battery drain.",
          backgroundTitle: "Tracking You.",
        },async function callback(location) {
          if(location?.simulated === true){
            await mockLog()
            resolve(lastLocation);
            BackgroundGeolocation.removeWatcher({id});
            return
          }
          lastLocation = location;
        }
      ).then(function retain_callback_id(the_id) {
          id = the_id;
      }).catch(()=>{
        massageAlert('error',"Aktifkan GPS!!!!!")
      });
      setTimeout(function () {
          resolve(lastLocation);
          BackgroundGeolocation.removeWatcher({id});
      }, timeout);
    });
  }

  const currentLocation = async () => {
    if (Capacitor.isNative) {
      CheckPermissions.requestFineLocation();
      guessLocation(50000)
    }
    const location = await Geolocation.getCurrentPosition({
      enableHighAccuracy: true,
    });
    setCoordinates(location)
  }

  const updateLocation = () => {
    currentLocation()
    if(Math.trunc(coordinates.coords.accuracy) > 1000) {
      massageAlert('error',"Check Kembali Akuransi Kamu,  Akurasi : " + Math.trunc(coordinates.coords.accuracy))
      return;
    }
    alert({
      header: 'Anda yakin Merubah Master Lokasi?',
      message: "Master Lokasi akan berubah jika ok",
      cssClass: 'header-alert',
      buttons: [
        {
          text: 'Cancel',
          cssClass: 'alert-button-cancel',
          role: 'cancel',
        },
        {
          text: t('yes'),
          cssClass: 'alert-button-confirm',
          role: 'confirm',
          handler: async () => {
            await presentLoading({message:`${t("loading")}`})
            currentLocation()
            await RestApi(
              `customer/update-location/${customer.customer_id}`,
              "post",
              {
                lat: coordinates.coords.latitude,
                lng: coordinates.coords.longitude,
                address_id: address?.customer_address_id,
              }
            )
              .then((res: any) => {
                if (res.data.code === 200) {
                  presentToast({
                    message: res.data.message,
                    duration: 1500,
                    icon: checkmarkCircleOutline,
                    color: "success",
                  });
                  dismissLoading();
                  props.onDismissDetail();
                } else {
                  presentToast({
                    message: res.data.message,
                    duration: 1500,
                    icon: closeCircleOutline,
                    color: "danger",
                  });
                  dismissLoading();
                }
              })
              .catch((error: any) => {
                presentToast({
                  message: error.message,
                  duration: 1500,
                  icon: closeCircleOutline,
                  color: "danger",
                });
                dismissLoading();
              });
          },
        },
      ]
    })
  }

  const resetLocation = () => {
    alert({
      header: 'Anda yakin Mereset Lokasi?',
      message: "Master Lokasi akan terhapus jika ok",
      cssClass: 'header-alert',
      buttons: [
        {
          text: 'Cancel',
          cssClass: 'alert-button-cancel',
          role: 'cancel',
        },
        {
          text: t('yes'),
          cssClass: 'alert-button-confirm',
          role: 'confirm',
          handler: async (data) => {
            await presentLoading({message:`${t("loading")}`})
            currentLocation()
            await RestApi(
              `customer/reset-location/${customer.customer_id}`,
              "post",
              {
                address_id: address?.customer_address_id,
              }
            )
              .then(async (res: any) => {
                if (res.data.code === 200) {
                  presentToast({
                    message: res.data.message,
                    duration: 1500,
                    icon: checkmarkCircle,
                    color: "success",
                  });
                  props.onDismissDetail();
                  dismissLoading();
                } else {
                  presentToast({
                    message: res.data.message,
                    duration: 1500,
                    icon: closeCircleOutline,
                    color: "danger",
                  });
                  dismissLoading();
                }
              })
              .catch((error: any) => {
                presentToast({
                  message: error.message,
                  duration: 1500,
                  icon: closeCircleOutline,
                  color: "danger",
                });
                dismissLoading();
              });
          },
        },
      ]
    })
  }

  const updateRadius = () => {
    alert({
      header: "Masukan Radius",
      cssClass: "header-alert",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "alert-button-cancel",
        },
        {
          text: t('yes'),
          role: "confirm",
          cssClass: "alert-button-confirm",
          handler: async (data) => {
            await presentLoading({ message: `${t("loading")}` });
            await RestApi(
              `customer/update-radius/${customer.customer_id}`,
              "post",
              {
                radius: data.radius,
                address_id: address?.customer_address_id,
              }
            )
              .then(async (res: any) => {
                if (res.data.code === 200) {
                  presentToast({
                    message: res.data.message,
                    duration: 1500,
                    icon: checkmarkCircleOutline,
                    color: "success",
                  });
                  dismissLoading();
                  props.onDismissDetail();
                } else {
                  try {
                    let messageObj = JSON.parse(res.data.message);
                    let message = "";
                    for (var key in messageObj) {
                      // skip loop if the property is from prototype
                      if (!messageObj.hasOwnProperty(key)) continue;
                      var obj = messageObj[key];
                      for (var prop in obj) {
                        // skip loop if the property is from prototype
                        if (!obj.hasOwnProperty(prop)) continue;
                        // your code
                        message += key + " = " + obj[prop];
                      }
                    }
                    presentToast({
                      message: message,
                      duration: 1500,
                      icon: closeCircleOutline,
                      color: "danger",
                    });
                  } catch (error) {
                    presentToast({
                      message: res.data.message,
                      duration: 1500,
                      icon: closeCircleOutline,
                      color: "danger",
                    });
                  }
                  dismissLoading();
                }
              })
              .catch((error: any) => {
                presentToast({
                  message: error.message,
                  duration: 1500,
                  icon: closeCircleOutline,
                  color: "danger",
                });
                dismissLoading();
              });
          },
        },
      ],
      inputs: [
        {
          placeholder: "Meter",
          type: "number",
          value: address?.customer_address_radius,
          name: "radius",
        },
      ],
    });
  };

  const navigateLocation = async () => {
    if(address?.customer_address_lat && address?.customer_address_lng) {
      if (Capacitor.isNative) {
        let options: LaunchNavigatorOptions = {
          start:`${coordinates?.coords?.latitude},${coordinates?.coords?.longitude}`,
          startName:"driving",
        }
        LaunchNavigator.navigate([address?.customer_address_lat,address?.customer_address_lng], options);
      }else{
        Browser.open({ url: `https://www.google.com/maps/dir/?api=1&destination=${address?.customer_address_lat},${address?.customer_address_lng}` });
      }
    }else{
      massageAlert('error',"Lokasi Pelanggan Belum Di Buat") 
    }
  }

  const checkStatus = ()  => {
    if (customer.visit_hist_type === null) {
      return (<IonFabButton data-desc="Check In" onClick={() => visitCust(0)} ><IonIcon size='medium' color='danger' icon={logInOutline} /></IonFabButton>);
    }else if (!visit.visitdet_note) {
      return (
        <IonFabButton
          data-desc="Catatan"
          onClick={() => {
            presentNote({ cssClass: "modal-fullscreen" });
          }}
        >
          <IonIcon
            size="medium"
            color="primary"
            icon={chatboxEllipsesOutline}
          />
        </IonFabButton>
      );
    }else if (customer.visit_hist_type === 0 ) {
      return (<IonFabButton data-desc="Check Out" onClick={() => visitCust(1)} ><IonIcon size='medium' color='success' icon={logOutOutline} /></IonFabButton>)
    }else if (customer.visit_hist_type === 1) {
      return (<IonFabButton data-desc="Check In" onClick={() => visitCust(0)} ><IonIcon size='medium' color='danger' icon={logInOutline} /></IonFabButton>);
    }
  }

  const visitCust = (type:number)  => {
    currentLocation()
    if(Math.trunc(coordinates.coords.accuracy) > 1000 ) {
      massageAlert('error',"Check Kembali Akuransi Anda,  Akurasi : " + Math.trunc(coordinates.coords.accuracy))
      return;
    }
    let longDistance = getDistance({
      latitude: Number(coordinates.coords.latitude),
      longitude: Number(coordinates.coords.longitude)
    },{
      latitude: Number(address?.customer_address_lat??coordinates.coords.latitude),
      longitude: Number(address?.customer_address_lng??coordinates.coords.longitude)
    })
    if (
      Math.trunc(longDistance) > Number(address?.customer_address_radius ?? 50)
    ) {
      massageAlert('error',`Lokasi Anda Di Luar Radius, Jarak Anda ${longDistance} Meter Dari Customer`);
      return;
    }
    if (bill.length && type === 1 && (visit.visitdet_bill_id === null || visit.visitdet_bill_id === "")) {
      massageAlert("error", `Harap Input Data Tagihan Terlebih Dahulu`);
      props.onDismissDetail();
      return;
    }
    presentLoading({message:`${t("loading")}`});
    RestApi(`visit/${visit.visit_id}`, "post", {
      lat: coordinates.coords.latitude,
      lng: coordinates.coords.longitude,
      customer_id: customer.customer_id,
      type: type,
      address_id: address?.customer_address_id
    })
      .then(async (res: any) => {
        if (res.data.code === 200) {
          massageAlert("success", res.data.message);
          dispatch(
            VisitAction.updateVisit({
              customer_id: customer.customer_id,
              visit_id: customer.visit_id,
              update: {
                visit_hist_type: type,
              },
            })
          );
          dispatch(
            CustomerAction.updateCustomer({
              visit_hist_type: type,
              customer_lat: coordinates.coords.latitude,
              customer_lng: coordinates.coords.longitude,
            })
          );
          if (type === 1) {
            await Preferences.set({ key: "visitOn", value: "" });
          }
          props.onDismissDetail();
          dismissLoading();
        } else {
          massageAlert("error", res.data.message);
          dismissLoading();
        }
      })
      .catch((error: any) => {
        massageAlert("error", error.message);
        dismissLoading();
      });
  }

  useConstructor( () => {
    currentLocation()
    setCustomer(props.customer)
    setVisit(props.visit)
    setAddress(props.address);
    setBill(props.bill);
  });

  useEffect(() => {
    setFocusLoc({
      latitude: address?.customer_address_lat ?? user.branchs.branch_lat,
      longitude: address?.customer_address_lng ?? user.branchs.branch_lng,
    });
  }, [visit, customer, address, user]);

  return (
    <IonPage className="ion-no-padding ion-no-margin">
      <IonFab vertical="top" horizontal="start" slot="fixed">
        <IonFabButton onClick={() => props.onDismissDetail()} color="dark">
          <IonIcon icon={arrowBackCircleOutline} />
        </IonFabButton>
      </IonFab>
      {isLoaded ? (
        <IonContent className="ion-no-padding ion-no-margin">
          <GoogleMap
            mapContainerClassName="google-map ion-no-padding ion-no-margin"
            center={{
              lat: Number(focusLoc.latitude ?? user.branchs.branch_lat),
              lng: Number(focusLoc.longitude ?? user.branchs.branch_lng),
            }}
            zoom={17}
            options={{
              streetViewControl: false,
              mapTypeControl: false,
              fullscreenControl: false,
              zoomControl: false,
              clickableIcons: false,
              keyboardShortcuts: false,
            }}
          >
            <Marker
              icon={{
                path: "M8 12l-4.7023 2.4721.898-5.236L.3916 5.5279l5.2574-.764L8 0l2.3511 4.764 5.2574.7639-3.8043 3.7082.898 5.236z",
                fillColor: "yellow",
                fillOpacity: 0.9,
                scale: 2,
                strokeColor: "gold",
                strokeWeight: 2,
              }}
              position={{
                lat: Number(
                  address?.customer_address_lat ?? user.branchs.branch_lat
                ),
                lng: Number(
                  address?.customer_address_lng ?? user.branchs.branch_lng
                ),
              }}
              onClick={() => setOnLoadInfoCust(!onLoadInfoCust)}
            />

            <Circle
              center={{
                lat: Number(
                  address?.customer_address_lat ?? user.branchs.branch_lat
                ),
                lng: Number(
                  address?.customer_address_lng ?? user.branchs.branch_lng
                ),
              }}
              // required
              options={{
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#FF0000",
                fillOpacity: 0.35,
                clickable: false,
                draggable: false,
                editable: false,
                visible: true,
                radius: Number(customer.customer_location_radius ?? 50),
                zIndex: 1,
              }}
            />

            {onLoadInfoCust && (
              <InfoWindow
                onCloseClick={() => setOnLoadInfoCust(!onLoadInfoCust)}
                position={{
                  lat: Number(
                    address?.customer_address_lat ?? user.branchs.branch_lat
                  ),
                  lng: Number(
                    address?.customer_address_lng ?? user.branchs.branch_lng
                  ),
                }}
              >
                <IonText className="ion-no-padding">
                  <h4>
                    <IonIcon
                      size="small"
                      className="ion-no-padding"
                      src={storefrontSharp}
                    />
                    <strong>{customer.customer_name}</strong>
                  </h4>
                  <p>
                    <strong>{`${address?.customer_address_name}, ${address?.customer_address}`}</strong>
                  </p>
                </IonText>
              </InfoWindow>
            )}

            {coordinates && (
              <Marker
                position={{
                  lat: Number(
                    coordinates?.coords?.latitude ?? user.branchs.branch_lat
                  ),
                  lng: Number(
                    coordinates?.coords?.longitude ?? user.branchs.branch_lng
                  ),
                }}
                onClick={() => setOnLoadInfoLoc(!onLoadInfoLoc)}
              />
            )}

            {onLoadInfoLoc && (
              <InfoWindow
                onCloseClick={() => setOnLoadInfoLoc(!onLoadInfoLoc)}
                position={{
                  lat: Number(
                    coordinates?.coords?.latitude ?? user.branchs.branch_lat
                  ),
                  lng: Number(
                    coordinates?.coords?.longitude ?? user.branchs.branch_lng
                  ),
                }}
              >
                <IonText className="ion-no-padding">
                  <h4>
                    <IonIcon
                      size="small"
                      className="ion-no-padding"
                      src={locateOutline}
                    />
                    <strong>Posisi Kamu</strong>
                  </h4>
                  <p>
                    <strong>
                      Akurasi : {Math.trunc(coordinates?.coords?.accuracy)}
                    </strong>
                  </p>
                </IonText>
              </InfoWindow>
            )}
          </GoogleMap>
          <IonFab horizontal="end" vertical="bottom">
            <IonFabButton className="fab-up" size="small">
              <IonIcon size="small" icon={menuSharp} />
            </IonFabButton>
            {props.type === "customer" ? (
              <IonFabList side="top">
                <IonFabButton data-desc="Navigasi" onClick={navigateLocation}>
                  <IonIcon size="medium" color="dark" icon={mapOutline} />
                </IonFabButton>
                {getRole?.role_menu_edit === 1 && (
                  <>
                    <IonFabButton
                      data-desc="Set Lokasi"
                      onClick={updateLocation}
                    >
                      <IonIcon
                        size="medium"
                        color="success"
                        icon={locateOutline}
                      />
                    </IonFabButton>
                    <IonFabButton data-desc="Reset" onClick={resetLocation}>
                      <IonIcon
                        size="medium"
                        color="danger"
                        icon={refreshCircleOutline}
                      />
                    </IonFabButton>
                    <IonFabButton data-desc="Set Radius" onClick={updateRadius}>
                      <IonIcon icon={navigateCircleOutline} />
                    </IonFabButton>
                  </>
                )}

                <IonFabButton data-desc="Lokasi Ku" onClick={checkLocation}>
                  <IonIcon
                    size="medium"
                    color="tertiary"
                    icon={navigateCircleOutline}
                  />
                </IonFabButton>
              </IonFabList>
            ) : (
              <IonFabList side="top">
                <IonFabButton data-desc="Navigasi" onClick={navigateLocation}>
                  <IonIcon size="medium" color="dark" icon={mapOutline} />
                </IonFabButton>
                {checkStatus()}
                {visit.visitdet_note && (
                  <IonFabButton
                    data-desc="Catatan"
                    onClick={() => {
                      presentNote({ cssClass: "modal-fullscreen" });
                    }}
                  >
                    <IonIcon
                      size="medium"
                      color="primary"
                      icon={chatboxEllipsesOutline}
                    />
                  </IonFabButton>
                )}
                <IonFabButton data-desc="Lokasi Ku" onClick={checkLocation}>
                  <IonIcon
                    size="medium"
                    color="tertiary"
                    icon={navigateCircleOutline}
                  />
                </IonFabButton>
              </IonFabList>
            )}
          </IonFab>
        </IonContent>
      ) : (
        <IonContent
          className="ion-padding"
          style={{ width: "100%", height: "100%" }}
        >
          <IonThumbnail style={{ width: "100%", height: "100%" }}>
            <IonSkeletonText
              style={{ width: "100%", height: "100%" }}
              animated={true}
            ></IonSkeletonText>
          </IonThumbnail>
        </IonContent>
      )}
    </IonPage>
  );
};

export default Map;
